import { appendAll, childElements, getElementById, moveAllChildren } from "../util/Utils";
import { localNavigation } from "../filtersheet/Selectors";
import { setLegacyLabels } from "../tracking/FeatureTracking";
import { eventQBus } from "../types/EventQBus";
import { setHcSheetNavigation, hcSheetState, HcSheetView } from "./hcSheetState.svelte";
import { isActive } from "../toggle/Toggle";

export const LOCAL_NAVIGATION = "localNavigation";
const NAVIGATION_HEADLINE = "Kategorien";
const FILTER_SHEET_ID = "heureka-hc-filtersheet";
const SHEET_CONTENT_SELECTOR = ".heureka_filterSheet__content";

let movedNavigationChildren: HTMLElement[] = [];

function sheetContent(): HTMLElement | null {
  return getElementById(FILTER_SHEET_ID)?.querySelector<HTMLElement>(SHEET_CONTENT_SELECTOR) ?? null;
}

export function isNavigationActive(): boolean {
  return hcSheetState.view === HcSheetView.Navigation;
}

function prepareContent(content: HTMLElement) {
  content.scrollTop = 0;
  content.dataset.filterId = LOCAL_NAVIGATION;

  setLegacyLabels(content, {
    san_FilterFoldoutType: LOCAL_NAVIGATION,
    san_FilterFoldoutActivity: "close",
    san_FacetChangeNothing: "view_selection",
  });
}

export function enterNavigation(): void {
  const content = sheetContent();
  if (!content) return;

  content.dataset.navigationActive = "true";
  const localNavigationChildren = childElements(localNavigation());
  if (localNavigationChildren) {
    if (isActive("HEUREKA_2469_EMPTY_SHEET_ON_LOCAL_NAVIGATION_BACK")) {
      movedNavigationChildren = localNavigationChildren;
    }
    content.append(...localNavigationChildren);
  }

  prepareContent(content);
  setHcSheetNavigation(true, NAVIGATION_HEADLINE);

  eventQBus.emit("ftfind.filterSheet.openedNavigation", {});
}

export function exitNavigation(): void {
  const content = sheetContent();
  setHcSheetNavigation(false);

  if (content) {
    delete content.dataset.filterId;
    delete content.dataset.tsLabels;
    delete content.dataset.navigationActive;
    if (isActive("HEUREKA_2469_EMPTY_SHEET_ON_LOCAL_NAVIGATION_BACK")) {
      /*                         */
      appendAll(movedNavigationChildren, localNavigation());
    } else {
      moveAllChildren(content, localNavigation());
    }
  }

  if (isActive("HEUREKA_2469_EMPTY_SHEET_ON_LOCAL_NAVIGATION_BACK")) {
    movedNavigationChildren = [];
  }

  eventQBus.emit("ftfind.filterSheet.closedNavigation");
}
